module.exports = __webpack_public_path__ + "img/pic@2x.3e7e1acd.png";